module.exports = __webpack_public_path__ + "img/03.1519a579.jpg";